module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"New EDIPART","name":"Edipart Name","description":"Edipart description","edipartWarningMessage":"EDI Part requires a name","notifyEdipartCreated":"EDI part successfully created"},"no":{"title":"Ny EDIPART","name":"Edipart navn","description":"Edipart description","edipartWarningMessage":"EDI Parten krever ett navn","notifyEdipartCreated":"EDI part opprettet"}}')
  delete Component.options._Ctor
}
